export const getAiImagePanelId = (parentPanelId: string): string => {
  return `${parentPanelId}-ai-image-via-ai-options`;
};

export const getAiSubtitlePanelId = (parentPanelId: string): string => {
  return `${parentPanelId}-ai-subtitle-via-ai-options`;
};

export const getAiVoicePanelId = (parentPanelId: string): string => {
  return `${parentPanelId}-ai-voice-via-ai-options`;
};

export const getAiVideoPanelId = (parentPanelId: string): string => {
  return `${parentPanelId}-ai-video-via-ai-options`;
};
